export const ALERT_ADDED = "ALERT_ADDED";
export const ALERT_REMOVED = "ALERT_REMOVED";
export const ALERTS_CLEARED = "ALERTS_CLEARED";
